import styled, { keyframes, css } from "styled-components";

export const BallsContainer = styled.div`
  display: grid;

  height: 394px;
  ${(p) => (p.mode80 ? "max-width: 320px;" : "max-width: 304px;")};

  margin: auto;
  margin-bottom: 20px;
  align-content: space-between;
  justify-content: space-between;
  ${(props) => props.isAutoOn && "pointer-events:none"}
  ${(props) =>
    props.mode80
      ? "grid-template-columns: auto auto auto auto auto auto auto auto;"
      : "grid-template-columns: auto auto auto auto auto;"}
 grid-template-rows: auto auto auto auto auto;
`;
const animation1 = keyframes`
   0% {
    animation-timing-function: cubic-bezier(.33,0,0,1.01);
    border-width: 0px;


    background-color: #32075b;
    font-size: 1em;
  }
  50% {
     border-width: 3px;


    background: none;
    animation-timing-function: ease-out;
    font-size: 0.28em;
  }
  100% {
    background: none;
     border-width: 3px;


    font-size: 1em;
   }
`;
const animation80 = keyframes`
   0% {
    animation-timing-function: cubic-bezier(.33,0,0,1.01);
    border: solid 0px #ffb000;
    background-color: #32075b;
    font-size: 0.7em;
  }
  50% {
    border: solid 3px #ffb000;
    background: none;
    animation-timing-function: ease-out;
    font-size: 0.2em;
  }
  100% {
    background: none;
    border: solid 3px #ffb000
    font-size: .7em;
   }
`;
const animation2 = keyframes`
    0% {
    animation-timing-function: cubic-bezier(.33,0,0,1.01);

    transform: scale(1);
    opacity: 0;
  }
  50% {
    animation-timing-function: ease-out;

    transform: scale(0.65);
       }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;
const animation3 = keyframes`
    0% {
    color: #7f3da5;
    animation-timing-function: ease-out;
   }
     100% {
    color: #ffb000;

   }
`;
const selectAnimS40 = css`
  ${animation1} .25s 1 forwards, ${animation2} .17s  1 forwards, ${animation3} .125s 1 forwards
`;
const selectAnim80 = css`
  ${animation80} .25s 1 forwards, ${animation2} .17s  1 forwards, ${animation3} .125s 1 forwards
`;
const unSelected1 = keyframes`
 
  0% {
    animation-timing-function: cubic-bezier(1, 0, 1, 1);
    font-size: 1em;
    border: solid 3px #ffb000
  }
  50% {
    animation-timing-function: cubic-bezier(1, 0, 0.67, 1);
    border: solid 0px #ffb000;
    font-size: 0.25em;
  }
  100% {
    border: solid 0px #ffb000;
    background-color: #32075b;
    font-size: 1em;
   }
`;
const unSelected2 = keyframes`
    0% {
    animation-timing-function: cubic-bezier(.33,0,0,1.01);

    transform: scale(1)
    opacity: 1;
  }
  50% {
    animation-timing-function: ease-out;

    transform: scale(0.65)
       }
  100% {
    transform: scale(1)
    opacity: 0;
  }
`;
const unSelected3 = keyframes`
    0% {
    color: #ffb000;
    animation-timing-function: ease-out;
   }
     100% {
    color: #7f3da5;

   }
`;
const unSelected = css`
  ${unSelected1} .25s 1  forwards ,  ${unSelected2} .176s  1 forwards, ${unSelected3} .125s 1 forwards
`;
const wonAnim1 = keyframes`
 
  0% {
    animation-timing-function: cubic-bezier(.33,0,0,1.01);
    font-size: 1em;
  }
  50% {
     animation-timing-function: ease-out;
     font-size: 0.28em;
  }
  100% {
     font-size: 1em;
   }
`;
const wonAnim2 = keyframes`
  0% {
    animation-timing-function: cubic-bezier(.33,0,0,1);
    transform: scale(1)
      }
  20% {
    animation-timing-function: cubic-bezier(0, 0, 0, 0.77);
     transform: scale(0.65)
       }
  40% {
    animation-timing-function: cubic-bezier(0, 0, 0, 0.77);
     transform: scale(0.65)
       }
  60% {
    animation-timing-function: cubic-bezier(0.25, 0.14, 0.58, 1);
     transform: scale(1.25)
       }
  100% {
    transform: scale(1)
    }
`;
const wonAnim3 = keyframes`
 
  0% {
    animation-timing-function: ease-out;
    color: #ffb000;
    background: #32075B;
    border: solid 3px #ffb000

   }
 
  100% {
    color: #FF0000;

    background: #FFB000;
    border: solid 0px #ffb000
    }
`;
const wonAnim4 = keyframes`
  0% {
    animation-timing-function: cubic-bezier(.33,0,0,1.01);
    opacity:0; 
 }
 33% {
      animation-timing-function: ease-out;
      opacity: 0.5
   }
  100% {
   opacity:0
   }
`;
const wonAnim = css`
  ${wonAnim1} 250ms 1  , ${wonAnim2} 417ms  1 , ${wonAnim3} 170ms 1 forwards
`;
const wonAnimDiv = css`
  ${wonAnim4} 0.5s 1 forwards
`;
const missAnim1 = keyframes`
   0% {
    animation-timing-function: cubic-bezier(.33,0,0,1.01);
    font-size: 1em;
  }
  50% {
     animation-timing-function: ease-out;
     font-size: 0.28em;
  }
  100% {
     font-size: 1em;
   }
`;
const missAnim2 = keyframes`
  0% {
    animation-timing-function: cubic-bezier(.33,0,0,1.01);
    transform: scale(1)
      }
  50% {
    animation-timing-function: ease-out;
    transform: scale(0.65)
       }
  100% {
    transform: scale(1)
    }
}`;
const missAnim3 = keyframes`
  0% {
  animation-timing-function: ease-out;
  color: #7f3da5;
  background: #32075B;
  }
   100% {
  color: #ffb000;
  background: #ff3920;
  }
`;

const missAnim = css`
  ${missAnim1} 0.25s 1  , ${missAnim2} .17s  1 , ${missAnim3} .17s 1 forwards
`;
export const Ball = styled.div`
  position: relative;
  animation: ${(p) =>
    p.selected
      ? p.mode40 || p.modeSonic
        ? selectAnimS40
        : selectAnim80
      : null};
  animation: ${(p) => (p.unSelected ? unSelected : null)};
  animation: ${(p) => (p.won ? wonAnim : null)};
  animation: ${(p) => (p.missed ? missAnim : null)};

  ${(props) =>
    props.mode40 || props.modeSonic
      ? "width: 46px; height: 46px; font-size: 1em; line-height: 100%;"
      : "width: 36px; height: 36px; font-size: 0.7em; line-height: 150%;"}
  background-color: #32075b;
  border: solid 0px #ffb000;

  color: #7f3da5;
  cursor: pointer;
  /* line-height: 100%; */
  border-radius: 45px;

  div {
    animation: ${(p) => (p.won ? wonAnimDiv : null)};
    animation: ${(p) => (p.missed ? null : null)};

    z-index: 2;
    position: absolute;
    width: 46px;
    height: 46px;
    background: #ffffff;
    opacity: 0;
    border-radius: 23px;
    ${(props) =>
      props.mode40 || props.modeSonic
        ? "width: 46px; height: 46px; font-size: 1em;"
        : "width: 36px; height: 36px; font-size: 0.7em;"}
  }
  span {
    position: absolute;
    height: 16px;
    width: 30px;
    text-align: center;
    line-height: 16px;
    left: 50%;
    margin-left: -15px;
    top: 50%;
    margin-top: -8px;
  }

  @-webkit-keyframes won-animation {
    0% {
      transform: scale(1);
    }
    25% {
      transform: scale(0.8);
    }
    50% {
      transform: scale(0.9);
    }
    75% {
      transform: scale(0.85);
    }
    100% {
      background-color: red;
      transform: scale(1);
    }
  }
  @keyframes won-animation {
    0% {
      background-color: #ffb000;
      transform: scale(1);
    }
    25% {
      transform: scale(0.8);
    }
    50% {
      transform: scale(0.9);
    }
    75% {
      transform: scale(0.85);
    }
    100% {
      background-color: #ff3920;
      color: #ffb000;
      transform: scale(1);
    }
  }
  @keyframes both-animation {
    0% {
      background-color: #ffb000;
      transform: scale(1);
    }
    25% {
      transform: scale(0.8);
    }
    50% {
      transform: scale(0.9);
    }
    75% {
      transform: scale(0.85);
    }
    100% {
      background-color: #ffb000;
      color: #ff3920;
      transform: scale(1);
    }
  }
`;
